import { render, staticRenderFns } from "./GlobalPeopleList.vue?vue&type=template&id=0fe84d29&scoped=true"
import script from "./GlobalPeopleList.vue?vue&type=script&lang=js"
export * from "./GlobalPeopleList.vue?vue&type=script&lang=js"
import style0 from "./GlobalPeopleList.vue?vue&type=style&index=0&id=0fe84d29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe84d29",
  null
  
)

export default component.exports